var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-news"},[_c('div',{staticClass:"news-title"},[_c('h2',[_vm._v(_vm._s(_vm.newsForm.newsTitle))])]),_vm._v(" "),_c('div',{staticClass:"news-infos",domProps:{"innerHTML":_vm._s(_vm.newsForm.newsDesc)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63860d41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NewsDetail.vue
// module id = null
// module chunks = 